import { gql } from '@apollo/client';

export const getActiveSessionsTotals = gql`
  query getActiveSessionsTotals($input: ActiveSessionsTotalsInput!) {
    getActiveSessionsTotals(input: $input) {
      totalKwh
    }
  }
`;
